import React from 'react';

import GCal from '../../assets/calendar/gcal.svg?react';
import ICal from '../../assets/calendar/ical.svg?react';
import Outlook from '../../assets/calendar/outlook.svg?react';

import CenteredModalWrapper from './centered-modal-wrapper';
import type { ModalProps } from './modal';

import { useTranslation } from '@/translations/useTranslation';

type Provider = 'google' | 'default' | 'outlookcom';

type AddToCalendarModalProps = ModalProps & {
  closeModal: (props?: { action: 'SELECTED'; provider: Provider } | { action: 'CLOSE' }) => void;
  getUrl: (provider: Provider) => string;
};

const AddToCalendarModal = ({ closeModal, getUrl }: AddToCalendarModalProps) => {
  const { t } = useTranslation();

  const handleSelect = (provider: Provider) => {
    const url = getUrl(provider);
    if (url.startsWith('BEGIN')) {
      const blob = new Blob([url], { type: 'text/calendar;charset=utf-8' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', 'download.ics');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(url, '_blank');
    }
    closeModal({ action: 'SELECTED', provider });
  };

  return (
    <CenteredModalWrapper onClose={closeModal} title={t('msg_add_to_calendar_modal_title')} limitWidth>
      <div className="flex flex-col gap-2">
        <button className="flex items-center gap-1" onClick={() => handleSelect('google')}>
          <GCal />
          Google Calendar
        </button>
        <button className="flex items-center gap-1" onClick={() => handleSelect('outlookcom')}>
          <Outlook />
          Outlook
        </button>
        <button className="flex items-center gap-1" onClick={() => handleSelect('default')}>
          <ICal />
          iCalc
        </button>
      </div>
    </CenteredModalWrapper>
  );
};

export default AddToCalendarModal;
